import { render, staticRenderFns } from "./ReviewsAnalytics.vue?vue&type=template&id=76ec33da&scoped=true&"
import script from "./ReviewsAnalytics.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec33da",
  null
  
)

export default component.exports